// lib/firebase-config.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyAhPqaTFTt7sWL8aNmGThZu9QnjJocLFkA',
  authDomain: 'test-notification-b6fe0.firebaseapp.com',
  projectId: 'test-notification-b6fe0',
  storageBucket: 'test-notification-b6fe0.firebasestorage.app',
  messagingSenderId: '14294132882',
  appId: '1:14294132882:web:b9204127dece84d8fbde4b',
  measurementId: 'G-JQCSX2GYZ4',
};

const app = initializeApp(firebaseConfig);
const messaging = typeof window !== 'undefined' ? getMessaging(app) : null;

export { messaging, getToken, onMessage };
